import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ComponentProps } from 'react';

import { Checkbox as BlocksCheckbox } from '~/components/blocks';

const Root = styled(BlocksCheckbox)<{ disabled?: boolean }>(({ theme, disabled }) =>
  css({
    ['& > input']: {
      [':checked + div:first-of-type']: {
        background: theme.colors.background.patientNavy,
        border: theme.borders.patientNavy,
        borderRadius: theme.radii.default,
      },
      ...(!disabled && {
        ['&:hover + div:first-of-type']: {
          border: theme.borders.patientNavy,
        },
      }),
    },
  }),
);

type Props = ComponentProps<typeof BlocksCheckbox>;

export const Checkbox = (props: Props) => {
  return <Root {...props} />;
};
